import React from 'react';

import { useSearch } from '../../hooks/context';
import { useStaticProps } from '../context/static-props';
import ContainerItems from '../grid-layout/container-items.desktop';

const BEST_SELLERS_ITEMS = 'BEST_SELLER';
const BEST_SELLERS_POLYCARDS = 'BEST_SELLER_POLYCARDS';

const renderDesktopContent = (props, preload, deviceType, countryConfig) => {
  if (!props) {
    return null;
  }

  const { id, trends_categories } = props;

  switch (id) {
    case BEST_SELLERS_POLYCARDS:
      return (
        <ContainerItems
          key={`${id}-trend`}
          component={trends_categories}
          preload={preload}
          deviceType={deviceType}
          countryConfig={countryConfig}
          preloadNumImage={3}
        />
      );

    default:
      return null;
  }
};

const BestSellerFactoryDesktop = () => {
  const { results } = useSearch();
  const { deviceType, country } = useStaticProps();
  const bestSellersItemsProps = results.find((x) => x.id === BEST_SELLERS_ITEMS || x.id === BEST_SELLERS_POLYCARDS);

  return [renderDesktopContent(bestSellersItemsProps, true, deviceType, country)];
};

export default BestSellerFactoryDesktop;
